// extracted by mini-css-extract-plugin
module.exports = {"ResturantHolder":"Restaurant_ResturantHolder__MGcy1","resturanImg":"Restaurant_resturanImg__1WSy_"};